import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigQuery } from '../../state/app-config/app-config.query';
import { SbHost } from '@models';

@Injectable({
    providedIn: 'root'
})
export class TempViewServiceService {
    constructor(private http: HttpClient, private appConfig: AppConfigQuery) {}

    getViews() {
        const url = `${this.appConfig.getBaseUrl(
            {
                hostEnum: SbHost.GatewayBaseUrl,
                resource:
                    'root-accounts/key-value?accountType=UNKNOWN,CASH_ACCOUNT,SECURITIES_ACCOUNT,ISK,KF,ACCOUNT,PORTFOLIO,MARGIN'
            },
            SbHost.GatewayBaseUrl
        )}`;
        return this.http.get<Array<{ value: number; label: string }>>(
            `${url}/root-accounts/key-value?accountType=UNKNOWN,CASH_ACCOUNT,SECURITIES_ACCOUNT,ISK,KF,ACCOUNT,PORTFOLIO,MARGIN`
        );
    }
}
